import React from "react";
import { Link } from "react-router-dom";

function SimpleMenu(props) {
  let menu = props.menu;

  return (
    <li>
      <Link to={menu.link || "/"}>
        <i className={menu.icon}></i>
        <span className="menu-text">{menu.title}</span>
        {menu.badge ? (
          <span className={"badge badge-pill " + menu.badge.class}>
            {" "}
            {menu.badge.text}{" "}
          </span>
        ) : (
          ""
        )}
      </Link>
    </li>
  );
}

export default SimpleMenu;
